// extracted by mini-css-extract-plugin
module.exports =  {"widget":"_2qNMLHXe4u1Z3Bqob8ymh3","content":"ROttDrdKf7SWGPZt2k9ve","widget-title":"JfC8H9We69iNnn7GVv71y","card":"uJ3f8cb4bCOwMiiVdqQui","empty-text":"_3DMDvCrtz0pc8gkR0yzvAn"};